const TailwindColors = () => {
  return (
    <>
      <div className='bg-cl-a hidden'></div>
      <div className='bg-cl-b hidden'></div>
      <div className='bg-cl-c hidden'></div>
      <div className='bg-cl-d hidden'></div>
      <div className='bg-cl-e hidden'></div>
      <div className='bg-cl-f hidden'></div>
    </>
  );
}
 
export default TailwindColors;
